import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#5192F6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.097 5.5v-2c0-.398-.16-.78-.447-1.06A1.54 1.54 0 0 0 7.573 2L5.54 6.5V12h5.731c.245.003.483-.082.67-.238a1 1 0 0 0 .346-.612l.701-4.5a.98.98 0 0 0-.237-.806 1.01 1.01 0 0 0-.779-.344zM5.54 12H4.016c-.27 0-.528-.105-.718-.293A1 1 0 0 1 3 11V7.5c0-.265.107-.52.298-.707.19-.188.449-.293.718-.293H5.54"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#5192F6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.54 6.5 7.573 2c.404 0 .791.158 1.077.44.286.28.447.662.447 1.06v2h2.875a1.03 1.03 0 0 1 .779.344 1 1 0 0 1 .238.806l-.702 4.5a1 1 0 0 1-.346.612c-.187.156-.425.24-.67.238h-5.73m0-5.5V12m0-5.5H4.015c-.27 0-.528.105-.718.293A1 1 0 0 0 3 7.5V11c0 .265.107.52.298.707.19.188.449.293.718.293H5.54"
    }, null, -1)
  ])))
}
export default { render: render }